module.exports = __webpack_public_path__ + "files/30e152d4777d3d9f019823b186d112ab.png";